module.exports = __webpack_public_path__ + "static/media/Inter-Regular.a90c493e.woff2";